export const JIRA_INTEGRATION_DETAIL_NAV = {
  CONFIGURATION: 'Configuration'
};

export const JIRA_INTEGRATION_DETAIL_LABELS = {
  PAGE_TITLE: 'Jira Cloud',
  GO_BACK: 'Go Back'
};

export const JIRA_CONNECTION_HEALTH_LABELS = {
  DISCONNECT: 'Disconnect',
  TEST_CONNECTION: 'Test connection',
  TESTING: 'Testing',
  CONNECTED: 'Connected',
  RECONNECT: 'Reconnect',
  REINSTALL: 'Reinstall',
  CONNECTION_HEALTH_TITLE: 'Connection health',
  CONNECTION_HEALTH_SUBTITLE: 'Active and working',
  CONNECTION_HEALTH_SUBTITLE_DISCONNECTED: 'Disconnected.',
  CONNECTION_HEALTH_SUBTITLE_AUTH_REQUIRED: 'Authorization required.',
  CONNECTION_HEALTH_SUBTITLE_APP_REMOVED: 'Installation incomplete. Finish setup in ',
  CONNECTION_HEALTH_SUBTITLE_RECONNECT_RESUME: 'Reconnect to resume',
  CONNECTION_HEALTH_SUBTITLE_ATLASSIAN_MARKETPLACE: 'Atlassian Marketplace',
  CONNECTION_HEALTH_SUBTITLE_RECONNECT_JIRA: 'Reconnect Jira restore',
  ALERT_DISCONNECTED: 'Jira integration is disconnected. Reconnect to enable Jira ticket creation.',
  ALERT_AUTH_EXPIRED: 'Jira authorization has expired. Reconnect to enable Jira ticket creation.',
  ALERT_APP_REMOVED: 'NetRise app was removed from Jira. Reinstall to enable Jira ticket creation.',
  RECONNECT_SUCCESS: 'Jira integration reconnected.',
  RECONNECT_ERROR: 'Failed to reconnect Jira integration.'
};

export const JIRA_CONNECTION_HEALTH_ISSUE = {
  DISCONNECTED: 'DISCONNECTED',
  AUTH_EXPIRED: 'AUTH_EXPIRED',
  APP_REMOVED: 'APP_REMOVED'
};

export const JIRA_CONNECTION_HEALTH_LINK_ACTION = {
  RECONNECT: 'RECONNECT',
  OPEN_MARKETPLACE: 'OPEN_MARKETPLACE',
  OPEN_AUTHORIZATION: 'OPEN_AUTHORIZATION'
};

export const JIRA_CONNECTION_METRIC_LABELS = {
  CONNECTED_SPACES: 'Jira spaces',
  LAST_UPDATED: 'Last updated',
  DISCONNECTED_ON: 'Disconnected on',
  EXPIRED: 'Expired',
  APP_REMOVED: 'App removed'
};

export const JIRA_SYSTEM_CHECK_STATUS = {
  ACTIVE: 'ACTIVE',
  WARNING: 'WARNING',
  ERROR: 'ERROR'
};

export const JIRA_DISCONNECT_MODAL_LABELS = {
  TITLE: 'Disconnect Atlassian Jira?',
  CANCEL: 'Cancel',
  CONFIRM: 'Disconnect',
  SUCCESS: 'Jira integration disconnected.',
  ERROR: 'Failed to disconnect Jira integration.',
  CONSEQUENCES: ["You won't be able to create new Jira tickets from NetRise findings until you reconnect."]
};

export const JIRA_TEST_CONNECTION_LABELS = {
  SUCCESS: 'Jira connection is healthy.',
  ERROR: 'Jira connection test failed.'
};
